import { resolveLink as r, resolveImage as t } from "../../../helpers/index.js";
function o(e) {
  return e === "light" ? "primary" : "light";
}
function l(e) {
  return e === "light" ? "link" : "light";
}
function s(e) {
  return ["cyan", "purple", "mos"][e % 3];
}
const a = (e) => ({
  color: e.properties?.themeIsDark ? "dark" : "light",
  subject: e.properties?.subject,
  body: e.properties?.text,
  header: e.properties?.header,
  mainLink: e.properties?.link && r(e.properties?.link?.[0]),
  mainLinkPrivate: e.properties?.linkIsBehindLogin,
  illustration: e.properties?.illustration?.[0] && t(e.properties?.illustration),
  secondaryLinks: e.properties?.secondaryLink?.map((i) => r(i)),
  tertiaryLinks: e.properties?.tertiaryLinks?.items?.map((i) => ({
    link: r(i.content.properties?.link?.[0]),
    linkPrivate: i.content.properties?.linkIsBehindLogin
  }))
});
export {
  a as recommendedLinkDeliveryApiParser,
  s as resolveColor,
  l as resolveThemeSubject,
  o as resolveThemeVariant
};
